<template>
  <div>
    <!-- Slider main container -->
    <div class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide">
          <img
            src="@/assets/img/眼部素材/kv.jpg"
            alt=""
          >
        </div>
      </div>
      <div class="bg">
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="goods">
      <div
        ref="box"
        class="item"
        v-for="(item,index) in imgRes"
        :key="index"
      >
        <div
          :class="isActive===index?'active bg-box':'bg-box'"
          :style="{height:heightNum+'px'}"
          @mouseenter="handleEnter(index)"
          @mouseleave="handleLeave"
          @click="handleRoute(item.id)"
        >
          <div
            class="bg default"
            :style="{background:'url('+item.defalut+') no-repeat center',backgroundSize:'cover'}"
          ></div>
          <div
            class="bg active"
            :style="{background:'url('+item.active+') no-repeat center',backgroundSize:'cover'}"
          ></div>
          <div class="name">{{item.enName}}</div>
        </div>
        <div class="box-b">
          <div class="desc">
            <div class="cname">{{item.zhName}}</div>
            <div class="info">{{item.intro}}</div>
          </div>
          <div
            class="btn"
            @click="handleRoute(item.id)"
          >Learn More</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <img
        class="bg"
        src="@/assets/img/眼部素材/bot.jpg"
      >
    </div>
  </div>
</template>

<script>
// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);
import { yanbuDetail } from './detail'

export default {
  data() {
    return {
      isActive: '',
      widthNum: 0,
      imgRes: [
        {
          defalut: require('@/assets/img/眼部素材/产品模特图/YXB1.jpg'),
          active: require('@/assets/img/眼部素材/产品模特图/YXB2.jpg'),
          name: 'Liquid Eye-liner',
          cname: '酵色「水粉笔」',
          info: '低饱和莫兰迪色 哑光粉雾妆效'
        },
        {
          defalut: require('@/assets/img/眼部素材/产品模特图/SCYP1.jpg'),
          active: require('@/assets/img/眼部素材/产品模特图/SCYP2.jpg'),
          name: 'Silky Silk Eyeshadow Palette',
          cname: '酵色「丝绸综合盘」',
          info: '独特又感性的橘绿粉撞色'
        },
        {
          defalut: require('@/assets/img/眼部素材/产品模特图/BKYP1.jpg'),
          active: require('@/assets/img/眼部素材/产品模特图/BKYP2.jpg'),
          name: 'Spiral Shell Glazed Lipgloss',
          cname: '酵色「贝壳综合盘」',
          info: '三重质地闪片 点染灵动双眸'
        },
        {
          defalut: require('@/assets/img/眼部素材/产品模特图/HPYP1.jpg'),
          active: require('@/assets/img/眼部素材/产品模特图/HPYP2.jpg'),
          name: 'Spiral Shell Eyeshadow Palette',
          cname: '酵色「琥珀综合盘」',
          info: '复古摩登 透明感纯欲妆'
        },
        {
          defalut: require('@/assets/img/眼部素材/产品模特图/Y2KYP1.jpg'),
          active: require('@/assets/img/眼部素材/产品模特图/Y2KYP2.jpg'),
          name: 'Future Nostalgia Matte Lipgloss',
          cname: '酵色「Y2K综合盘」',
          info: '电光金属外壳 高彩火龙果撞色'
        },
        // {
        //   defalut: require('@/assets/img/眼部素材/产品模特图/MB1.jpg'),
        //   active: require('@/assets/img/眼部素材/产品模特图/MB2.jpg'),
        //   name: 'Winter Sweet Lip Oil',
        //   cname: '酵色「极细眉笔」',
        //   info: '根根分明 精细描绘持久眉妆'
        // }
      ],
    }
  },
  computed: {
    heightNum() {
      return this.widthNum
    }
  },
  created() {
    this.imgRes = yanbuDetail
  },
  methods: {
    handleEnter(i) {
      this.isActive = i
    },
    handleLeave(i) {
      this.isActive = ''
    },
    handleRoute(id) {
      const name = '眼部'
      this.$router.push({ name: 'detail', query: { id, name } })
    }
  },
  mounted() {
    this.widthNum = this.$refs.box[0].clientWidth
    window.onresize = () => {
      this.widthNum = this.$refs.box[0].clientWidth
    }
    const swiper = new Swiper('.swiper-container', {
      //   autoplay: {
      //     delay: 3000,
      //     disableOnInteraction: false
      //   },
      speed: 2000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'my-bullet',
        bulletActiveClass: 'my-bullet-active',
      },
    });
  }
}
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 51rem;
  .bg {
    position: absolute;
    top: 50%;
    left: 50%;
    // width: 456px;
    // height: 216px;
    width: 18.8rem;
    height: 9rem;
    transform: translate(-50%, -50%);
    background: url("../../../assets/img/眼部素材/text.png") no-repeat center;
    background-size: cover;
    z-index: 1;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.goods {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 61px 0 66px;
  .item {
    margin-bottom: 61px;
    width: 45%;

    .bg-box {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .bg.default {
        opacity: 1;
        transition: 0.4s;
      }
      .bg.active {
        transform: scale(1.1);
        opacity: 0;
        transition: 0.6s ease-out;
      }
      .name {
        position: absolute;
        top: 9px;
        left: 7px;
        color: #ffffff;
      }
    }
    .bg-box.active {
      .bg.default {
        opacity: 0;
      }
      .bg.active {
        transform: scale(1);
        opacity: 1;
      }
    }
    .box-b {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 14px;
      font-size: 12px;
      .btn {
        width: 89px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-size: 13px;
        border: 1px solid #0a0406;
        cursor: pointer;
      }
    }
  }
}
.bottom {
  position: relative;
  .bg {
    width: 100%;
    height: 100%;
  }
}
</style>